// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W0sFvXdikOcAh6rJgX_R{gap:5px;padding-left:12px}.xWkMbG9t_ktq4H15H79r input{flex:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `W0sFvXdikOcAh6rJgX_R`,
	"collapsed": `xWkMbG9t_ktq4H15H79r`
};
export default ___CSS_LOADER_EXPORT___;
